import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Div,
  Input,
  Text
} from 'ui'
import { isValid } from 'ui/Input/validators'
import FormRequirement from '../FormRequirement'


const FormCreatePassword = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  onSuccess
}) => {

  const { t } = useTranslation()

  const [confirmPwdError, setConfirmPwdError] = useState('')

  const handlePwd = (pwd) => {
    setPassword(pwd)
    setConfirmPwdError('')
  }

  const handleChangeConfirm = (pwd) => {
    setConfirmPwdError('')
    setConfirmPassword(pwd)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      const errorMsg = t('passwordsDontMatch')
      setConfirmPwdError(errorMsg)
      return
    }

    onSuccess()
  }

  return (
    <Div
      as='form'
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      flexGrow={1}
      width='100%'
      onSubmit={handleSubmit}
    >

      <div>
        <Text
          size='xl'
          color='headline'
          weight='semibold'
          align='center'
        >
          {t('createPassword')}
        </Text>

        <Div
          display='flex'
          flexDirection='column'
          gap={16}
          marginTop={32}
        >
          <Input.Password
            label={t('password')}
            onChange={handlePwd}
            value={password}
            autoFocus
          />

          <Input.Password
            label={t('repeatPassword')}
            onChange={handleChangeConfirm}
            value={confirmPassword}
            error={confirmPwdError}
          />
        </Div>

        <FormRequirement
          isCompleted={isValid.passwordHasLowerCase(password)}
          description={t('mustContainOneLowerCase')}
        />
        <FormRequirement
          isCompleted={isValid.passwordHasUpperCase(password)}
          description={t('mustContainOneUpperCase')}
        />
        <FormRequirement
          isCompleted={isValid.passwordHasNumber(password)}
          description={t('mustContainOneNumber')}
        />
        <FormRequirement
          isCompleted={isValid.passwordLength(password)}
          description={t('lengthMinMax', { min: '8', max: '30' })}
        />
      </div>

      <Div marginBottom={35}>
        <Button
          isFull
          size='large'
          disabled={!isValid.password(password)}
        >
          {t('next')}
        </Button>
      </Div>
    </Div>
  )
}

export default FormCreatePassword